<!--
 * @Descripttion: 验证码登陆组件
 * @version: 3.0
 * @Author: zhangfan
 * @email: 2207044692@qq.com
 * @Date: 2024-11-27 17:21:16
 * @LastEditors: zouxin
 * @LastEditTime: 2024-12-17 09:47:17
-->
<template>
  <div class="login-form-wrapper">
    <a-form-model :model="form" :rules="rules" ref="loginForm" layout="vertical" class="login-form">
      <a-form-model-item prop="phoneNumber">
        <a-input
          v-model="form.phoneNumber"
          :placeholder="$t('base.phoneNumber')"
          allow-clear
          autocomplete="new-password"
          hide-button
          :disabled="loading"
        ></a-input>
      </a-form-model-item>

      <a-form-model-item prop="password">
        <a-input-password
          v-model="form.password"
          :placeholder="$t('base.password')"
          allow-clear
          autocomplete="new-password"
          hide-button
          :disabled="loading"
        ></a-input-password>
      </a-form-model-item>

      <div class="register-box">
        <a-checkbox v-model="rememberMe" :disabled="loading">
          <span style="font-size: 14px; color: #ffffff">{{ $t('base.rememberPassword') }}</span>
        </a-checkbox>
        <div class="register-link">
          <span style="color: #0166fc; margin-right: 10px" @click="forgetPwd">{{ $t('base.forgetPassword') }}</span>
        </div>
      </div>

      <a-form-model-item prop="code" style="margin-top: 10px">
        <a-input
          class="codeInput"
          style="width: 100%; height: 40px"
          v-model="form.code"
          :placeholder="$t('base.code')"
          :maxLength="6"
          allow-clear
          hide-button
          :disabled="loading"
        >
          <template #suffix>
            <div
              class="send-code"
              :class="{ disabled: isCountingDown || loading }"
              v-if="!isCountingDown"
              @click="sendCode"
            >
              {{ $t('base.getCode') }}
            </div>
            <div v-else style="width: 100%; height: 100%; font-size: 14px; color: #a2a5ae">
              {{ countdown }}{{ $t('base.afterSecondResend') }}
            </div>
          </template>
        </a-input>
      </a-form-model-item>

      <div class="register-box">
        <span class="send-help">
          <a
            href="https://ucnu9t4fowy8.feishu.cn/wiki/Jr8MwN6SniPn4KkrVQ6cbgMCnmc#share-Rxv5dW7BSoIalXx2QvacUQNvnBg"
            target="_blank"
          >
            {{ $t('base.noCode') }}
          </a>
        </span>
        <div class="register-link">
          <span style="color: #0166fc; margin-right: 10px" @click="skipToRegisterPage">{{
            $t('base.accountRegister')
          }}</span>
        </div>
      </div>

      <a-button type="primary" class="sbmitBtn" @click="handleSubmit">{{ $t('base.immediateLogin') }}</a-button>
    </a-form-model>
  </div>
</template>
<script>
import { sendCaptchaLogin, codeLogin, getSecret } from '@/api/user'
import {
  queryConfigByCode,
  checkAccountStatus,
  checkPassword,
  sendCaptchaCode,
  captchaLogin,
  resetPassword,
} from '@/api/auth'
import aes from '@/utils/aes'
import { getUserInfo } from '@/utils/auth'
import store from '@/store'
import { setToken } from './auth'
import { setComToken, transferComtoken } from '@/utils/comToken'

export default {
  data() {
    return {
      form: {
        phoneNumber: '',
        password: '',
        code: '',
      },
      countdown: 0,
      errorMessage: '',
      loading: false,
      isSendCode: false, //是否发过验证码
      rememberMe: false,
      secret: '', // 密码加密密钥
      captchaInfo: {
        captchaKey: '',
        captchaCode: '',
      },
    }
  },
  computed: {
    isAgree() {
      return this.$store.getters.LoginInfo.isAgree
    },
    isCountingDown() {
      return this.countdown > 0 || false
    },
    loginConfig() {
      return this.$store.getters.loginConfig
    },
    rules() {
      return {
        phoneNumber: [
          { required: true, message: this.$t('base.phoneNotEmpty'), trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('base.passwordNotEmpty'), trigger: 'blur' },
          { validator: this.validatePassword, trigger: 'blur' },
        ],
        code: [
          { required: true, message: this.$t('base.codeNotEmpty'), trigger: 'blur' },
          { pattern: /^\d{6}$/, message: this.$t('base.codeFormatError'), trigger: 'blur' },
        ],
      }
    },
  },
  async mounted() {
    this.init()
    const secretResult = await getSecret()
    this.secret = secretResult.secret
    console.log(secretResult, 'secretResult')
  },
  methods: {
    // 验证手机号
    validatePhone(rule, value, callback) {
      console.log('valuevalue', value)
      const phoneReg = /^1[3456789]\d{9}$/
      if (!phoneReg.test(value)) {
        callback(new Error(this.$t('base.phoneNumberError')))
      } else {
        callback()
      }
    },

    // 验证密码
    validatePassword(rule, value, callback) {
      // 密码必须包含大小写字母、数字、特殊字符中的至少三种，且长度不少于8位
      const passwordValidate =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^(){}=+`~/！|,.\[\];'":、—_<>《》：“-])[A-Za-z\d@$!%*?&#^(){}=+`~/！|,.\[\];'":、—_<>《》：“-]{8,}$/
      if (!value) {
        callback(new Error('请输入密码'))
      }
      // else if (!passwordValidate.test(value)) {
      //   callback(new Error(this.$t('base.passwordRule', [8])))
      // }
      else {
        callback()
      }
    },
    // 校验账号状态
    async fetchCheckAccountStatus() {
      const params = {
        phone: this.form.phoneNumber,
        // clientId: this.$store.getters.loginConfig.clientId,
      }
      try {
        const res = await checkAccountStatus(params)
        if (res.code === 200) {
          return true
        } else {
          this.$message.error(res.message || '账号不存在')
          return false
        }
      } catch (error) {}
    },
    // 校验密码
    async fetchCheckPassword() {
      let key = aes.decrypt(this.loginConfig.key, 'cbim2192cbim2192')
      const params = {
        username: this.form.phoneNumber,
        password: aes.sm4Encrypt(this.form.password, key),
        clientId: this.loginConfig.clientId,
      }
      try {
        const res = await checkPassword(params)
        if (res.code === 0) {
          return true
        } else {
          this.$message.error(res.msg || '密码错误')
          return false
        }
      } catch (error) {
        return false
      }
    },
    // 原始获取验证码
    async sendCodeOld() {
      this.isSendCode = true
      try {
        // 先验证手机号
        const phoneReg = /^1[3456789]\d{9}$/
        if (!phoneReg.test(this.form.phoneNumber)) {
          his.$message.warning(this.$t('tip.pleaseInputCorrectPhoneNumber'))
          return
        }
        this.loading = true
        const res = await sendCaptchaLogin(this.form.phoneNumber)
        if (res.code === 200) {
          this.$message.success(this.$t('tip.captchaSentSuccess'))
          this.startCountdown()
        } else {
          this.$message.error(res.message || this.$t('tip.captchaSentFailed'))
        }
      } catch (error) {
        // this.$message.error('发送验证码失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    // 获取验证码
    async sendCode() {
      if (this.loginConfig.authType !== 'center_auth') {
        this.sendCodeOld()
        return
      }
      // 校验账号状态
      const isAccountValid = await this.fetchCheckAccountStatus()
      if (!isAccountValid) {
        return
      }
      // 校验密码
      const isPasswordValid = await this.fetchCheckPassword()
      console.log(isPasswordValid)

      if (!isPasswordValid) {
        return
      }

      this.isSendCode = true
      try {
        // 先验证手机号
        const phoneReg = /^1[3456789]\d{9}$/
        if (!phoneReg.test(this.form.phoneNumber)) {
          this.$message.warning(this.$t('tip.pleaseInputCorrectPhoneNumber'))
          return
        }
        this.loading = true
        const res = await sendCaptchaCode({
          identifier: this.form.phoneNumber,
          clientId: this.loginConfig.clientId,
        })
        if (res.code === 0) {
          this.startCountdown()
          this.captchaInfo = { captchaKey: res.data, captchaCode: res.msg }
          this.$message.success(this.$t('tip.captchaSentSuccess'))
        } else {
          this.$message.error(res.message || this.$t('tip.captchaSentFailed'))
        }
      } catch (error) {
        // this.$message.error('发送验证码失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    // 启动倒计时
    startCountdown() {
      const TIME_COUNT = 60
      this.countdown = TIME_COUNT
      const interval = setInterval(() => {
        if (this.countdown > 0 && this.countdown <= TIME_COUNT) {
          this.countdown -= 1
        } else {
          clearInterval(interval)
        }
      }, 1000)
    },
    init() {
      const savedphoneNumber = localStorage.getItem('phoneNumber')
      const savedPassword = localStorage.getItem('password')
      if (savedphoneNumber) this.form.phoneNumber = savedphoneNumber
      if (savedPassword) this.form.password = savedPassword
      if (savedphoneNumber && savedPassword) {
        this.rememberMe = true
      }
    },
    // 原始提交登录
    async handleSubmitOld() {
      try {
        // 表单验证
        await this.$refs.loginForm.validate()

        if (!this.isSendCode) {
          this.$message.error(this.$t('tip.pleaseGetCaptcha'))
          return
        }

        if (!this.isAgree) {
          this.$message.error(this.$t('tip.pleaseReadTip'))
          return
        }

        this.loading = true
        const params = {
          phone: this.form.phoneNumber,
          password: aes.encrypt(this.form.password, 'cbim2192cbim2192'),
          verifyCode: this.form.code,
        }

        // 调用验证码登录接口
        const loginRes = await codeLogin(params)
        
        if (loginRes.code === 200) {
          // 记住密码
          if (this.rememberMe) {
            localStorage.setItem('phoneNumber', this.form.phoneNumber)
            localStorage.setItem('password', this.form.password)
          } else {
            localStorage.removeItem('phoneNumber')
            localStorage.removeItem('password')
          }
          localStorage.setItem('userInfo', JSON.stringify(loginRes.result.userInfo))
          store.commit('user/SET_INFO', loginRes.result.userInfo)
          store.commit('user/SET_IsShowNav', true)
          this.$message.success(this.$t('tip.loginSuccess'))
          setToken(loginRes.result?.jjtToken)
          // 登录成功后跳转
          const redirect = this.$route.query.redirect || '/'
          this.$router.push(redirect)
        } else {
          this.$message.error(loginRes.message || this.$t('tip.loginFailed'))
        }
      } catch (error) {
        console.error('登录异常:', error)
        // this.$message.error(error.message || this.$t('tip.loginFailed'))
      } finally {
        this.loading = false
      }
    },

    // 提交登录
    async handleSubmit() {
      if (this.loginConfig.authType !== 'center_auth') {
        this.handleSubmitOld()
        return
      }
      try {
        // 表单验证
        await this.$refs.loginForm.validate()

        if (!this.isSendCode) {
          this.$message.error(this.$t('tip.pleaseGetCaptcha'))
          return
        }

        if (!this.isAgree) {
          this.$message.error(this.$t('tip.pleaseReadTip'))
          return
        }

        this.loading = true
        const params = {
          identifier: this.form.phoneNumber,
          captchaKey: this.captchaInfo.captchaKey,
          captchaCode: this.form.code,
          clientId: this.loginConfig.clientId,
        }
        // 调用验证码登录接口
        const loginRes = await captchaLogin(params)
        if (loginRes.code === 0) {
          if (loginRes.data.resetPassword == 1) {
            // 重置密码
            // window.open(
            //   `${process.env.VUE_APP_RESET_PASSWORD}?&redirectUrl=${location.origin + process.env.VUE_APP_PUBLIC_PATH}`,
            //   '_self'
            // )
            setToken(loginRes.data?.accessToken)
            setComToken(loginRes.data?.comToken)
            this.skipToResetPwdPage()
            return
            // const resetRes = await resetPassword({
            //   comToken: loginRes.data.comToken,
            //   password: aes.sm4Encrypt(this.form.password, key),
            // })
          }
          // 记住密码
          if (this.rememberMe) {
            localStorage.setItem('phoneNumber', this.form.phoneNumber)
            localStorage.setItem('password', this.form.password)
          } else {
            localStorage.removeItem('phoneNumber')
            localStorage.removeItem('password')
          }
          this.$message.success(this.$t('tip.loginSuccess'))
          console.log(loginRes)

          setToken(loginRes.data?.accessToken)
          console.log(getUserInfo())

          localStorage.setItem('userInfo', JSON.stringify(getUserInfo()))
          store.commit('user/SET_INFO', getUserInfo())
          store.commit('user/SET_IsShowNav', true)
          // comToken 存储
          setComToken(loginRes.data?.comToken)
          //向中转页发送comToken
          transferComtoken(this.loginConfig.schemaViewUrl,loginRes.data?.comToken)
          // 登录成功后跳转
          const redirect = this.$route.query.redirect || '/'
          this.$router.push(redirect)
        } else {
          this.$message.error(loginRes.mag || this.$t('tip.loginFailed'))
        }
      } catch (error) {
        console.error('登录异常:', error)
      } finally {
        this.loading = false
      }
    },

    // 忘记密码
    forgetPwd() {
      this.$router.push('/forgetPwd')
    },

    // 跳转到注册页面
    skipToRegisterPage() {
      this.$router.push({
        path: '/register',
      })
    },
    // 跳转到重置密码页面
    skipToResetPwdPage() {
      this.$router.push({
        path: '/resetPwd',
      })
    },
  },
}
</script>

<style lang="less" scoped>
.login-form {
  margin-top: 20px;
  font-size: 18px;

  .incocss {
    font-size: 18px;
    margin-right: 3px;
  }

  &-wrapper {
    width: 360px;
    color: #fff;
  }

  /deep/.ant-input {
    height: 40px;
    background-color: #222222;
    border: none;
    border-radius: 8px;

    &:focus {
      box-shadow: none;
    }
  }

  /deep/.ant-select-selector {
    background-color: #222222 !important;
    border: none !important;
    border-radius: 8px !important;
  }

  /deep/.ant-input-affix-wrapper {
    background-color: #222222;
    border: none;
    border-radius: 8px;

    &:focus,
    &-focused {
      box-shadow: none;
    }

    .ant-input {
      background-color: transparent;
      color: #fff;
    }
    .anticon {
      color: #a2a5ae;
    }
  }
}
.buttonCodeClass {
  font-size: 18px;
}

.register-box {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 10px;
  position: relative;
  bottom: 10px;
  padding: 0px 5px;

  .register-link {
    color: #0166fc;
    cursor: pointer;
  }

  .send-help {
    font-size: 14px;
    a {
      color: #ffffff;
    }
  }
}

.sbmitBtn {
  width: 360px;
  height: 40px;
  background: #0166fc;
  border-radius: 8px 8px 8px 8px;
}

.codeInput {
  /deep/.anticon-close-circle {
    margin-right: 5px;
  }
}

.send-code {
  cursor: pointer;
  color: #0166fc;
  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

/deep/.ant-form-item-label > label {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #a2a5ae;
}
</style>
